<h3 #h3 class="ui primary header" style="padding: 2rem 1rem">
  {{ getTitle(toEdit) }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="ui label warning-label">
  <span>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="#2C6ECB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>

  <div class="text">
    <span>Please note:</span>
    Any changes made here will be verified before it appears on your profile
  </div>
</div>
<div
  class="ui basic segment"
  *ngIf="success || error"
  appMargin="0"
  appPadding="0"
>
  <esl-message-toast [duration]="10000" [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<div
  class=""
  style="
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    padding: 2rem 1rem;
  "
>
  <div class="contents" style="flex-grow: 1; overflow: auto">
    <div class="content" style="margin-top: 20px">
      <div
        class="scroll-wrapper ui basic segment"
        [ngClass]="{ loading: pending }"
        appPadding="0"
      >
        <form class="ui form" [formGroup]="organizationForm">
          <ng-container *ngIf="toEdit == 'COMPANY_NAME'">
            <div class="ui basic section">
              <h2 class="ui head">Company Name</h2>
              <div class="ui divider"></div>

              <div
                class="field"
                [ngClass]="displayFieldCss('companyName')"
                appMargin
                marginB="15px"
              >
                <label class="required">Name</label>
                <input type="text" formControlName="companyName" />

                <app-field-error-display
                  [displayError]="isFieldValid('companyName')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="toEdit == 'RC_NUMBER'">
            <div class="ui basic section">
              <h2 class="ui head">Company Registration Details</h2>
              <div class="ui divider"></div>

              <div
                class="field"
                [ngClass]="displayFieldCss('rcNumber')"
                appMargin
                marginB="15px"
              >
                <label class="required">RC Number</label>
                <input #input type="text" formControlName="rcNumber" />
                <app-field-error-display
                  [displayError]="isFieldValid('rcNumber')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('companyType')"
                appMargin
                marginB="15px"
              >
                <label class="required">Company Type</label>
                <sui-select
                  class="selection"
                  formControlName="companyType"
                  [options]="companyTypeData"
                  labelField="optionName"
                  valueField="optionId"
                  #select
                >
                  <sui-select-option
                    *ngFor="let option of select.filteredOptions"
                    [value]="option"
                  >
                  </sui-select-option>
                </sui-select>
                <app-field-error-display
                  [displayError]="isFieldValid('companyType')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('ownershipType')"
                appMargin
                marginB="15px"
              >
                <label class="required">Ownership Type</label>
                <sui-select
                  class="selection"
                  formControlName="ownershipType"
                  [options]="ownershipType"
                  labelField="optionName"
                  valueField="optionId"
                  #deselect
                >
                  <sui-select-option
                    *ngFor="let option of deselect.filteredOptions"
                    [value]="option"
                  >
                  </sui-select-option>
                </sui-select>
                <app-field-error-display
                  [displayError]="isFieldValid('ownershipType')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('dateOfRegistration')"
                appMargin
                marginB="15px"
              >
                <label class="required">Registration Date</label>
                <input
                  suiDatepicker
                  [pickerMode]="mode"
                  [pickerMaxDate]="max"
                  placeholder="Date of registration"
                  type="text"
                  formControlName="dateOfRegistration"
                />
                <app-field-error-display
                  [displayError]="isFieldValid('dateOfRegistration')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="toEdit == 'TIN'">
            <div class="ui basic section">
              <h2 class="ui head">
                {{
                  isBusinessName
                    ? "FIRS Tax identification Number"
                    : "Company TIN"
                }}
              </h2>
              <div class="ui divider"></div>
              <div
                class="field"
                [ngClass]="displayFieldCss('tinNumber')"
                appMargin
                marginB="15px"
              >
                <!-- <label class="required">Enter your TCC ID/NO</label> -->

                <label class="required">Tax Identification Number</label>
                <input type="text" formControlName="tinNumber" />

                <app-field-error-display
                  [displayError]="isFieldValid('tinNumber')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="toEdit == 'OTHER_TIN'">
            <div class="ui basic section">
              <h2 class="ui head">Other Tax Identification Number</h2>
              <div class="ui divider"></div>

              <div
                class="field"
                [ngClass]="displayFieldCss('tinNumber')"
                appMargin
                marginB="15px"
              >
                <label class="required">Tax Identification Number</label>
                <input type="text" formControlName="tinNumber" />

                <app-field-error-display
                  [displayError]="isFieldValid('tinNumber')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="toEdit == 'ADDRESS'">
            <div class="ui basic section">
              <h2 class="ui head">Company Address</h2>
              <div class="ui divider"></div>

              <div
                class="field"
                [ngClass]="displayFieldCss('headOfficeAddressStreet')"
                appMargin
                marginB="15px"
              >
                <label class="required">Street</label>
                <input
                  #input
                  type="text"
                  formControlName="headOfficeAddressStreet"
                />
                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressStreet')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('headOfficeAddressCity')"
                appMargin
                marginB="15px"
              >
                <label class="required">Area/City</label>
                <input type="text" formControlName="headOfficeAddressCity" />
                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressCity')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('headOfficeAddressStateId')"
                appMargin
                marginB="15px"
              >
                <label class="required">State</label>

                <select
                  class="ui fluid dropdown"
                  placeholder="Select State"
                  formControlName="headOfficeAddressStateId"
                >
                  <option *ngFor="let opt of states" [ngValue]="opt.stateId">
                    {{ opt.stateName }}
                  </option>
                </select>
                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressStateId')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('headOfficeAddressZip')"
                appMargin
                marginB="15px"
              >
                <label class="">Zip Code</label>
                <input type="text" formControlName="headOfficeAddressZip" />
                <!-- <app-field-error-display
              [displayError]="isFieldValid('headOfficeAddressZip')"
              errorMsg="Please provide detail"
            >
            </app-field-error-display> -->
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('countryOfRegistration')"
                appMargin
                marginB="15px"
              >
                <label class="required">Country</label>
                <select
                  class="ui dropdown large"
                  placeholder="Select Country"
                  formControlName="countryOfRegistration"
                >
                  <option
                    *ngFor="let opt of countries"
                    [ngValue]="opt.countryCode"
                  >
                    {{ opt.countryName }}
                  </option>
                </select>
                <app-field-error-display
                  [displayError]="isFieldValid('countryOfRegistration')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="toEdit == 'CONTACT_INFORMATION'">
            <div class="ui basic section">
              <h2 class="ui head">Contact Information</h2>
              <div class="ui divider"></div>

              <div
                class="field"
                [ngClass]="displayFieldCss('companyContactEmail')"
                appMargin
                marginB="15px"
              >
                <label class="required">Email Address</label>
                <input type="text" formControlName="companyContactEmail" />
                <div
                  *ngIf="companyEmailLoading"
                  class="ui fluid red basic label"
                  style="margin: 0.3em 0"
                >
                  <div class="ui tiny active inline loader"></div>
                  checking email availability
                </div>
                <div
                  *ngIf="companyEmailServerError"
                  class="ui fluid red basic label"
                >
                  Oops! there seems to be a network problem,please try again
                </div>
                <div
                  class="ui pointing red basic label"
                  *ngIf="!companyEmailError"
                >
                  Email already exist, please enter again.
                </div>
                <app-field-error-display
                  [displayError]="isFieldValid('companyContactEmail')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>
              <div
                class="field"
                [ngClass]="displayFieldCss('companyContactAlternativeEmail')"
                appMargin
                marginB="15px"
              >
                <label class="required">Alternative Email Address</label>
                <input
                  type="text"
                  formControlName="companyContactAlternativeEmail"
                />
                <app-field-error-display
                  [displayError]="
                    isFieldValid('companyContactAlternativeEmail')
                  "
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('companyContactPhone1')"
                appMargin
                marginB="15px"
              >
                <label class="required">Phone Number</label>
                <input type="text" formControlName="companyContactPhone1" />
                <app-field-error-display
                  [displayError]="isFieldValid('companyContactPhone1')"
                  errorMsg="Please provide detail"
                >
                </app-field-error-display>
              </div>

              <div
                class="field"
                [ngClass]="displayFieldCss('website')"
                appMargin
                marginB="15px"
              >
                <label class="">Website</label>
                <input type="text" formControlName="website" />
                <!-- <app-field-error-display
              [displayError]="isFieldValid('website')"
              errorMsg="Please provide detail"
            >
            </app-field-error-display> -->
              </div>
            </div>
          </ng-container>
        </form>
        <form
          class="ui form"
          appMargin
          style="margin-bottom: 30px; flex-direction: column; margin-top: 30px"
          *ngIf="
            (toEdit == 'ADDRESS' ||
              (toEdit == 'TIN' && proceedToSubmitTin) ||
              toEdit == 'OTHER_TIN') &&
            uploads.length > 0
          "
        >
          <h2 class="ui head" fxFlex="auto">Upload Supporting Document</h2>
          <p>
            Click the plus (+) button to upload new document. You can link any
            similar document you have uploaded before now by choosing the Link
            option. Only .pdf, .doc and .ppt files can be uploaded
          </p>
          <div>
            <div
              *ngFor="let document of documentss; let i = index"
              style="margin-bottom: 20px"
            >
              <div fxLayout="row" style="width: 100%">
                <label
                  fxFlex="auto"
                  [ngClass]="{ required: document.isRequired }"
                >
                  Upload {{ document.documentTypeName }}
                </label>
                <div suiDropdown>
                  <button
                    class="ui tiny icon button"
                    style="
                      border: none !important;
                      align-items: center !important;
                    "
                    style="float: right"
                    *ngIf="
                      !(
                        ((toEdit == 'TIN' && proceedToSubmitTin) ||
                          toEdit == 'OTHER_TIN') &&
                        (document.uploadedFiles.length > 0 ||
                          returnDocumentType(
                            allLinkedDocuments,
                            document.documentTypeName
                          ).length > 0)
                      )
                    "
                  >
                    <i
                      class="ui plus icon hoverable"
                      suiPopup
                      [popupInverted]="true"
                      popupPlacement="bottom"
                      popupText="upload Document"
                    ></i>
                  </button>
                  <div
                    class="menu"
                    style="
                      height: 80px;
                      margin-top: 40px;
                      position: absolute;
                      width: 100px;
                      right: 0px;
                      width: fit-content;
                      z-index: 1000;
                    "
                    suiDropdownMenu
                    appPadding
                    paddingX="3"
                  >
                    <div
                      class="item"
                      style="
                        font-family: 'Roboto';
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 14.06px;
                        text-align: left;
                        color: #505050;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        height: 40px;
                        cursor: pointer;
                      "
                      (click)="uploader.click()"
                    >
                      <input
                        #uploadDoc
                        type="file"
                        accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                        #uploader
                        multiple
                        (change)="onFileChanges($event, document)"
                        placeholder="Browse for documents"
                        onclick="value = null"
                        style="display: none"
                      />
                      Upload new document
                    </div>
                    <a
                      class="item"
                      style="
                        font-family: 'Roboto';
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 14.06px;
                        text-align: left;
                        color: #505050;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        height: 40px;
                        cursor: pointer;
                      "
                      (click)="LinkDocument(document.documentTypeName)"
                      >Link an existing document</a
                    >
                  </div>
                </div>
              </div>
              <div
                style="width: 100%"
                class="ui divider"
                appMargin
                marginT="1"
              ></div>
              <div
                *ngIf="
                  returnDocumentType(
                    allLinkedDocuments,
                    document.documentTypeName
                  ).length > 0
                "
                style="width: 100%"
                class="field"
                appMargin
                marginT="5px"
              >
                <div
                  class="item"
                  style="
                    padding: 16px 0px;
                    color: #3f4395;
                    font-size: 14px;
                    font-weight: 500;
                  "
                >
                  Linked existing documents of {{ document.documentTypeName }}
                </div>
                <ng-container class="document">
                  <div
                    *ngFor="
                      let doc of returnDocumentType(
                        allLinkedDocuments,
                        document.documentTypeName
                      );
                      let i = index
                    "
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 64px;
                        border-top: 1px solid #dfdfdf;
                        width: 100%;
                      "
                    >
                      <div style="display: flex; align-items: center">
                        <img
                          src="../../../../../assets/icons/pdfdoc.svg"
                          alt="data"
                        />
                        <p
                          style="
                            margin-left: 20px;
                            font-style: normal;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 16px;
                            color: #505050;
                          "
                        >
                          {{ doc.documentName }}
                        </p>
                      </div>
                      <div>
                        <div
                          style="
                            align-items: center !important;
                            gap: 8px;
                            display: flex;
                            justify-content: flex-end;
                          "
                        >
                          <a
                            href="{{ baseUrl }}/public/media/?media={{
                              doc.documentPath
                            }}"
                            target="_blank"
                          >
                            <i class="eye icon"></i>
                          </a>
                          <div
                            class="ui button"
                            style="
                              background-color: #eaeffb;
                              border-radius: 8px;
                            "
                            (click)="
                              editLinkedDocument(
                                doc,
                                i,
                                document.documentTypeName
                              )
                            "
                          >
                            Edit
                          </div>
                          <img
                            class="hoverable"
                            src="assets/icons/cancel.svg"
                            (click)="removeLinkedDocument(doc, i)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div style="width: 100%" class="field" appMargin marginT="5px">
                <ng-container
                  *ngIf="
                    document.uploadedFiles && document.uploadedFiles.length > 0
                  "
                >
                  <ng-container
                    *ngFor="
                      let file of document.uploadedFiles;
                      let fileIndex = index
                    "
                  >
                    <div
                      fxLayout="row"
                      fxLayoutGap="10px"
                      fxLayoutAlign="start center"
                      appMargin
                      marginB="15px"
                    >
                      <div
                        fxFlex="grow"
                        class="ui segment"
                        style="border-radius: 8px"
                      >
                        <div
                          fxFlex="row"
                          fxLayoutGap="10px"
                          fxLayoutAlign="start center"
                        >
                          <div fxFlex="10">
                            <img
                              src="assets/icons/file-type/doc-upload.svg"
                              alt=""
                            />
                          </div>
                          <div fxFlex="75">
                            <div>
                              {{ file.name }}
                            </div>
                          </div>
                          <div fxFlex fxLayoutAlign="end">
                            <div
                              class="ui button"
                              style="
                                background-color: #eaeffb;
                                border-radius: 8px;
                              "
                              (click)="uploaderEdit.click()"
                            >
                              <input
                                #uploadDoc
                                type="file"
                                accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                                #uploaderEdit
                                multiple
                                (change)="editFile($event, document, fileIndex)"
                                placeholder="Edit document"
                                onclick="value = null"
                                style="display: none"
                              />
                              Edit
                            </div>
                            <img
                              class="hoverable"
                              src="assets/icons/cancel.svg"
                              (click)="removeFile(document, fileIndex)"
                            />
                          </div>
                        </div>
                      </div>
                    </div> </ng-container
                ></ng-container>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div
      class="actions"
      style="
        background: transparent;
        border: none;
        position: relative;
        margin-top: 20px;
      "
    >
      <button class="ui basic primary button" (click)="modal.deny(undefined)">
        Close
      </button>
      <button
        class="ui primary button"
        [ngClass]="{ yellow: pending }"
        [disabled]="pending || !organizationForm.valid"
        (click)="confirmDocumentSelected()"
        *ngIf="toEdit !== 'TIN'"
        autofocus
      >
        Done
      </button>

      <button
        class="ui primary button"
        [ngClass]="{ yellow: pending }"
        [disabled]="pending || !organizationForm.valid"
        (click)="confirmDocumentSelected()"
        *ngIf="toEdit === 'TIN' && proceedToSubmitTin"
        autofocus
      >
        Done
      </button>

      <button
        class="ui primary button"
        [ngClass]="{ yellow: pending }"
        [disabled]="pending || !organizationForm.valid"
        (click)="confirmTin()"
        *ngIf="toEdit === 'TIN' && !proceedToSubmitTin"
        autofocus
      >
        Continue
      </button>
    </div>
  </div>
</div>
